import { Component, Inject, OnInit } from '@angular/core';
import * as agentsActions from '../../../../store/agents.actions';
import { IAgent } from 'src/app/features/agents/models/agents.models';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { Observable, takeUntil } from 'rxjs';
import { ICustomer } from 'src/app/features/customers/models/customers.models';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-agent-catalogs-add-dialog',
  templateUrl: './agent-catalogs-add-dialog.component.html',
  styleUrls: ['./agent-catalogs-add-dialog.component.scss']
})
export class AgentCatalogsAddDialogComponent implements OnInit {
  agent: IAgent | null = null;

  customers$: Observable<ICustomer[]> = this.store.select(
    (state) => state.customers.customers
  );
  customers: ICustomer[] = [];
  initialSelectedCatalogs: number[] = [];
  pricelist_ids: number[] = [];

  filter: any | undefined = undefined;
  unparsedFilter: any | undefined = undefined;

  destroy$ = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<AgentCatalogsAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.initialSelectedCatalogs = this.data.pricelist_ids;
    this.pricelist_ids = this.initialSelectedCatalogs;
   
    this.agent = this.data.agent;

    this.actions$.pipe(
      ofType(agentsActions.UpdateAgentSuccess),
      takeUntil(this.destroy$)
    ).subscribe((action) => {
      this.dialogRef.close();
    });
  }

  selectedCatalogsChange(catalogs: number[]) {
    this.pricelist_ids = catalogs;
  }

  save() {
    if (!this.agent?.id || this.initialSelectedCatalogs === this.pricelist_ids) return;

    this.store.dispatch(agentsActions.UpdateAgent({
      id: this.agent.id!,
      agent: { pricelist_ids: this.pricelist_ids }
    }));
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
